module.exports = __webpack_public_path__ + "img/qy-bg.0e7410fa.jpg";